import styled from "styled-components";
import { TransitionGroup } from "react-transition-group";

export const TransitionContainer = styled(TransitionGroup)`
  position: relative;
  background-color: white;
  height: 100%;
`;
